import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Report = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M7.0716 14.2034v5.8625c0 .3191-.1097.5886-.3292.8082-.2197.2195-.4891.3293-.8083.3293-.3191 0-.5885-.1098-.8082-.3293-.2195-.2196-.3293-.4891-.3293-.8082V4.9344c0-.3192.1098-.5886.3293-.8083.2197-.2195.489-.3292.8082-.3292h7.2945c.2692 0 .5074.0859.7148.2577.2071.172.3397.3906.3977.6558l.2263 1.0865h4.4982c.3192 0 .5886.1097.8083.3292.2195.2197.3292.4891.3292.8083v8.1315c0 .3191-.1097.5886-.3292.8082-.2197.2195-.4891.3293-.8083.3293h-5.2945c-.2691 0-.5074-.0859-.7147-.2578-.2072-.172-.3398-.3906-.3978-.6557l-.2262-1.0865H7.0716z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M7.0716 14.2034v5.8625c0 .3191-.1097.5886-.3292.8082-.2197.2195-.4891.3293-.8083.3293-.3191 0-.5885-.1098-.8082-.3293-.2195-.2196-.3293-.4891-.3293-.8082V4.9344c0-.3192.1098-.5886.3293-.8083.2197-.2195.489-.3292.8082-.3292h7.2945c.2692 0 .5074.0859.7148.2577.2071.172.3397.3906.3977.6558l.2263 1.0865h4.4982c.3192 0 .5886.1097.8083.3292.2195.2197.3292.4891.3292.8083v8.1315c0 .3191-.1097.5886-.3292.8082-.2197.2195-.4891.3293-.8083.3293h-5.2945c-.2691 0-.5074-.0859-.7147-.2578-.2072-.172-.3398-.3906-.3978-.6557l-.2262-1.0865H7.0716zm7.644-.275h3.2125V8.0719h-4.3055c-.2691 0-.5073-.086-.7145-.258-.2073-.1719-.34-.3904-.398-.6555l-.226-1.0865H7.0716v5.8565h6.3055c.2692 0 .5074.086.7145.258.2074.1718.34.3903.398.6555l.226 1.0865z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M7.0716 14.2034v5.8625c0 .3191-.1097.5886-.3292.8082-.2197.2195-.4891.3293-.8083.3293-.3191 0-.5885-.1098-.8082-.3293-.2195-.2196-.3293-.4891-.3293-.8082V4.9344c0-.3192.1098-.5886.3293-.8083.2197-.2195.489-.3292.8082-.3292h7.2945c.2692 0 .5074.0859.7148.2577.2071.172.3397.3906.3977.6558l.2263 1.0865h4.4982c.3192 0 .5886.1097.8083.3292.2195.2197.3292.4891.3292.8083v8.1315c0 .3191-.1097.5886-.3292.8082-.2197.2195-.4891.3293-.8083.3293h-5.2945c-.2691 0-.5074-.0859-.7147-.2578-.2072-.172-.3398-.3906-.3978-.6557l-.2262-1.0865H7.0716zm7.644-.275h3.2125V8.0719h-4.3055c-.2691 0-.5073-.086-.7145-.258-.2073-.1719-.34-.3904-.398-.6555l-.226-1.0865H7.0716v5.8565h6.3055c.2692 0 .5074.086.7145.258.2074.1718.34.3903.398.6555l.226 1.0865z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Report.displayName = "ReportIcon";

export { Report, Report as default };
